<template>
	<div class="popup" :class="popup_type">
		<div class="popup-bg"></div>
		<div class="popup-content">
			<component :is="'popup-' + popup_type" :popup="popup" @close="close" />
		</div>
		
		<div v-if="popup_type !== 'end-game' && popup_type !== 'credits' && popup_type !== 'unlock'" class="close" v-hammer:tap="close">x</div>
	</div>
</template>

<script>
import PopupCard from '@/components/global/popup/popup-card'
import PopupGameMenu from '@/components/global/popup/popup-game-menu'
import PopupSettings from '@/components/global/popup/popup-settings'
import PopupCredits from '@/components/global/popup/popup-credits'
import PopupEndGame from '@/components/global/popup/popup-end-game'
import PopupUnlock from '@/components/global/popup/popup-unlock'
import PopupReset from '@/components/global/popup/popup-reset'

export default {
	name: 'popup',
	data() {
		return {
			is_closable: true
		}
	},
	props: {
		popup: { default: null }
	},
	computed: {
		popup_type() {
			return this.popup.type
		}
	},
	methods: {
		close() {
			this.$store.dispatch('remove_popup', { popup: this.popup })
		}
	},
	components: { PopupCard, PopupGameMenu, PopupSettings, PopupCredits, PopupEndGame, PopupUnlock, PopupReset }
}
</script>

<style lang="stylus" scoped>

.popup
	absolute 0
	flex center center
	
	// &.popup-leave-active
	// 	transition opacity 0.1s linear
	// &.popup-leave-to
	// 	opacity 0
		
	&.popup-enter-active
		transition opacity 0.2s easeOutQuart
		.popup-content
			transition opacity 0.2s easeOutQuart
	&.popup-enter
		.popup-content
			opacity 0
		
	&.end-game.popup-enter-active
		transition transform 1s easeOutQuart, opacity 0.5s easeOutQuart
		.popup-content
			transition 0.5s easeOutQuart 0.5s
	&.end-game.popup-enter
		opacity 0
		.popup-content
			opacity 0
			transform scale(1.1)
			
	.popup-bg
		absolute 0
		background-color alpha(darken(#000, 50%), 90%)
	.popup-content
		width 100%
		height 100%
	.close
		position absolute
		top 32px
		right 32px
		width 80px
		height 80px
		flex center center
		font-size 8rem
		color #fff
		transition 0.15s easeOutQuart
		&:hover
			transform scale(1.1)
		&:active
			transform scale(0.9)

</style>
